<template>
  <div class="modern-feedback">
    <div class="feedback-container">
      <!-- 新增头部装饰元素 -->
      <div class="header-decoration">
        <div class="decoration-circle circle-1"></div>
        <div class="decoration-circle circle-2"></div>
        <div class="decoration-wave"></div>
      </div>

      <div class="feedback-header">
        <div class="header-icon">
          <i class="el-icon-chat-dot-round"></i>
        </div>
        <h1 class="feedback-title">留言反馈</h1>
        <p class="feedback-subtitle">您的建议对我们非常重要，帮助我们做得更好</p>
      </div>

      <el-form 
        :model="form" 
        :rules="rules" 
        ref="form"
        class="modern-form"
        label-position="top">
        
        <!-- 反馈标题 -->
        <el-form-item label="反馈标题" prop="address" class="form-item">
          <div class="input-container">
            <i class="el-icon-edit input-icon"></i>
            <el-input 
              v-model="form.address"
              placeholder="请简要描述反馈内容"
              maxlength="100"
              class="modern-input">
            </el-input>
          </div>
        </el-form-item>

        <!-- 反馈描述 -->
        <el-form-item label="反馈描述" prop="synopsis" class="form-item">
          <div class="textarea-container">
            <i class="el-icon-document textarea-icon"></i>
            <el-input
              v-model="form.synopsis"
              type="textarea"
              :rows="5"
              placeholder="请详细描述您遇到的问题或建议"
              maxlength="500"
              class="modern-textarea"
              show-word-limit>
            </el-input>
          </div>
        </el-form-item>

        <!-- 相关截图 -->
        <el-form-item label="相关截图" class="form-item">
          <div class="upload-section">
            <div class="upload-header">
              <i class="el-icon-picture"></i>
              <span>上传截图</span>
              <span class="upload-tips">（支持JPG/PNG格式，每张不超过2MB）</span>
            </div>
            
            <div class="upload-grid">
              <el-upload
                class="image-upload"
                action="http://148.70.177.170:8089/uploadManager/upload"
                :multiple="true"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <div class="upload-card">
                  <div class="upload-card-inner">
                    <i class="el-icon-plus upload-icon"></i>
                    <div class="upload-text">点击上传</div>
                    <div class="upload-subtext">最多可上传10张</div>
                  </div>
                </div>
              </el-upload>

              <div 
                class="image-preview"
                v-for="(image, index) in form.imageUrl"
                :key="index">
                <div class="preview-badge">{{ index + 1 }}</div>
                <img :src="image" class="preview-image">
                <div class="preview-actions">
                  <el-tooltip content="预览" placement="top">
                    <i class="el-icon-view" @click="previewImage(image)"></i>
                  </el-tooltip>
                  <el-tooltip content="删除" placement="top">
                    <i class="el-icon-delete" @click="removeImage(index)"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>

        <!-- 提交按钮区域 -->
        <div class="submit-section">
          <div class="button-group">
            <el-button 
              class="submit-btn" 
              @click="submitForm('form')"
              :loading="loading">
              <i class="el-icon-message"></i>
              {{ loading ? '提交中...' : '提交反馈' }}
            </el-button>
            
            <el-button class="back-btn" @click="goHome">
              <i class="el-icon-house"></i>
              返回首页
            </el-button>
          </div>
        </div>
      </el-form>
    </div>

    <!-- 图片预览对话框 -->
    <el-dialog 
      :visible.sync="previewVisible"
      width="80%"
      top="5vh"
      class="image-preview-dialog"
      :close-on-click-modal="true">
      <div class="dialog-header" slot="title">
        <i class="el-icon-picture"></i>
        <span>图片预览</span>
      </div>
      <div class="dialog-content">
        <img :src="previewImageUrl" class="preview-dialog-image">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { tjjj } from "../api/all.js"

export default {
  name: 'JylyView',
  data() {
    return {
      form: {
        address: '',
        synopsis: '',
        imageUrl: []
      },
      rules: {
        address: [
          { required: true, message: '请输入反馈标题', trigger: 'blur' },
          { min: 5, max: 100, message: '标题长度在 5 到 100 个字符', trigger: 'blur' }
        ],
        synopsis: [
          { required: true, message: '请输入反馈描述', trigger: 'blur' },
          { min: 10, max: 500, message: '描述长度在 10 到 500 个字符', trigger: 'blur' }
        ]
      },
      loading: false,
      previewVisible: false,
      previewImageUrl: ''
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      
      // 检查图片数量
      if (this.form.imageUrl.length >= 10) {
        this.$message.error('最多只能上传10张图片!')
        return false
      }
      
      return true
    },
    handleAvatarSuccess(res, file) {
      this.form.imageUrl.push(res.pic)
      this.$message.success('图片上传成功')
    },
    removeImage(index) {
      this.$confirm('确定要删除这张图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.imageUrl.splice(index, 1)
        this.$message.success('图片已删除')
      })
    },
    previewImage(url) {
      this.previewImageUrl = url
      this.previewVisible = true
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            const res = await tjjj({
              name: this.form.address,
              desc: this.form.synopsis,
              images: this.form.imageUrl
            })
            
            if (res.status == 1) {
              this.$message.success(res.msg)
              this.$refs[formName].resetFields()
              this.form.imageUrl = []
            } else {
              this.$message.error(res.msg)
            }
          } catch (error) {
            this.$message.error('提交失败，请重试')
          } finally {
            this.loading = false
          }
        }
      })
    },
    goHome() {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>

<style lang="less" scoped>
.modern-feedback {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  
  @media (max-width: 768px) {
    padding: 0;
    min-height: 100vh;
    align-items: stretch;
  }
}

/* 头部装饰元素 */
.header-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
  
  .decoration-circle {
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
  }
  
  .circle-1 {
    width: 200px;
    height: 200px;
    top: -100px;
    right: -50px;
  }
  
  .circle-2 {
    width: 150px;
    height: 150px;
    bottom: -75px;
    left: -50px;
  }
  
  .decoration-wave {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z' fill='rgba(255,255,255,0.1)'%3E%3C/path%3E%3C/svg%3E");
    background-size: cover;
  }
}

.feedback-container {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(255, 255, 255, 0.2);
  padding: 50px;
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  position: relative;
  z-index: 1;
  
  @media (max-width: 768px) {
    padding: 30px 25px;
    border-radius: 0;
    flex: 1;
    justify-content: space-between;
    backdrop-filter: none;
    background: white;
  }
}

.feedback-header {
  text-align: center;
  margin-bottom: 50px;
  position: relative;
  
  .header-icon {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 25px;
    box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
    
    i {
      font-size: 32px;
      color: white;
    }
  }
  
  .feedback-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #2d3748;
    margin-bottom: 15px;
    background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    
    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }
  
  .feedback-subtitle {
    color: #718096;
    font-size: 1.1rem;
    margin: 0;
    font-weight: 400;
  }
}

.modern-form {
  .form-item {
    margin-bottom: 35px;
    
    /deep/ .el-form-item__label {
      font-weight: 600;
      color: #2d3748;
      margin-bottom: 12px;
      display: block;
      font-size: 15px;
      letter-spacing: 0.5px;
    }
  }
  
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* 输入框容器 */
.input-container,
.textarea-container {
  position: relative;
  
  .input-icon,
  .textarea-icon {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #a0aec0;
    z-index: 2;
    font-size: 18px;
  }
  
  .textarea-icon {
    top: 24px;
    transform: none;
  }
}

.modern-input {
  /deep/ .el-input__inner {
    height: 56px;
    border-radius: 12px;
    border: 2px solid #e2e8f0;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: #f8fafc;
    padding-left: 50px;
    font-size: 15px;
    
    &:focus {
      border-color: #667eea;
      box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
      background: white;
    }
    
    &::placeholder {
      color: #a0aec0;
    }
  }
}

.modern-textarea {
  /deep/ .el-textarea__inner {
    border-radius: 12px;
    border: 2px solid #e2e8f0;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: #f8fafc;
    resize: vertical;
    min-height: 140px;
    padding: 16px 16px 16px 50px;
    font-size: 15px;
    line-height: 1.5;
    
    &:focus {
      border-color: #667eea;
      box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
      background: white;
    }
    
    &::placeholder {
      color: #a0aec0;
    }
  }
}

.upload-section {
  .upload-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    
    i {
      color: #667eea;
      font-size: 20px;
    }
    
    span {
      font-weight: 600;
      color: #2d3748;
      font-size: 15px;
    }
    
    .upload-tips {
      color: #718096;
      font-size: 13px;
      font-weight: normal;
    }
  }
}

.upload-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 20px;
}

.image-upload {
  /deep/ .el-upload {
    width: 100%;
  }
}

.upload-card {
  width: 100%;
  height: 140px;
  border: 2px dashed #cbd5e0;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #f8fafc;
  position: relative;
  overflow: hidden;
  
  &:hover {
    border-color: #667eea;
    background: rgba(102, 126, 234, 0.05);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.15);
    
    .upload-icon {
      color: #667eea;
      transform: scale(1.1);
    }
  }
  
  .upload-card-inner {
    text-align: center;
  }
  
  .upload-icon {
    font-size: 28px;
    color: #a0aec0;
    margin-bottom: 8px;
    transition: all 0.3s ease;
  }
  
  .upload-text {
    font-size: 14px;
    color: #4a5568;
    font-weight: 500;
    margin-bottom: 4px;
  }
  
  .upload-subtext {
    font-size: 12px;
    color: #718096;
  }
}

.image-preview {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: white;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
    
    .preview-actions {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .preview-badge {
    position: absolute;
    top: 8px;
    left: 8px;
    background: rgba(102, 126, 234, 0.9);
    color: white;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    z-index: 1;
  }
  
  .preview-image {
    width: 100%;
    height: 140px;
    object-fit: cover;
    display: block;
    transition: transform 0.3s ease;
  }
  
  .preview-actions {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(transparent, rgba(0,0,0,0.8));
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    padding: 15px;
    opacity: 0;
    transform: translateY(10px);
    transition: all 0.3s ease;
    
    i {
      color: white;
      font-size: 18px;
      cursor: pointer;
      padding: 8px;
      border-radius: 8px;
      background: rgba(255,255,255,0.2);
      transition: all 0.3s ease;
      
      &:hover {
        background: #667eea;
        transform: scale(1.1);
      }
    }
  }
}

/* 提交按钮区域 */
.submit-section {
  margin-top: auto;
  padding-top: 30px;
  border-top: 1px solid #f0f0f0;
  
  @media (max-width: 768px) {
    position: sticky;
    bottom: 0;
    background: white;
    padding: 20px 0 0;
    margin-top: 40px;
  }
}

.button-group {
  display: flex;
  gap: 15px;
  
  @media (max-width: 480px) {
    flex-direction: column;
  }
}

.submit-btn {
  flex: 2;
  height: 56px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 14px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
  position: relative;
  overflow: hidden;
  
  i {
    margin-right: 8px;
    font-size: 18px;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
    transition: left 0.6s;
  }
  
  &:hover::before {
    left: 100%;
  }
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 35px rgba(102, 126, 234, 0.5);
  }
  
  &:active {
    transform: translateY(-1px);
  }
  
  &.is-loading {
    background: linear-gradient(135deg, #a3bffa 0%, #b794f4 100%);
  }
}

.back-btn {
  flex: 1;
  height: 56px;
  background: transparent;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  color: #4a5568;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  i {
    margin-right: 6px;
  }
  
  &:hover {
    border-color: #667eea;
    color: #667eea;
    background: rgba(102, 126, 234, 0.05);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.15);
  }
}

/* 图片预览对话框 */
.image-preview-dialog {
  /deep/ .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
  }
  
  /deep/ .el-dialog__header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 20px 25px;
    border-bottom: none;
    
    .el-dialog__title {
      color: white;
      font-weight: 600;
    }
    
    .el-dialog__headerbtn {
      top: 20px;
      
      .el-dialog__close {
        color: white;
        font-size: 18px;
        
        &:hover {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
  }
  
  /deep/ .el-dialog__body {
    padding: 0;
    background: #f8fafc;
  }
}

.dialog-header {
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;
  
  i {
    font-size: 20px;
  }
  
  span {
    font-weight: 600;
    font-size: 16px;
  }
}

.dialog-content {
  padding: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.preview-dialog-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  display: block;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .modern-feedback {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }
  
  .upload-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 15px;
  }
  
  .upload-card,
  .image-preview .preview-image {
    height: 120px;
  }
  
  .image-preview-dialog {
    /deep/ .el-dialog {
      width: 95% !important;
      margin-top: 2vh !important;
    }
  }
  
  .header-decoration {
    display: none;
  }
}

@media screen and (max-width: 480px) {
  .upload-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .feedback-header .header-icon {
    width: 60px;
    height: 60px;
    
    i {
      font-size: 24px;
    }
  }
  
  .submit-btn,
  .back-btn {
    height: 50px;
    font-size: 14px;
  }
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.feedback-container {
  animation: fadeInUp 0.6s ease-out;
}

.form-item {
  animation: fadeInUp 0.6s ease-out;
  animation-fill-mode: both;
}

.form-item:nth-child(1) { animation-delay: 0.1s; }
.form-item:nth-child(2) { animation-delay: 0.2s; }
.form-item:nth-child(3) { animation-delay: 0.3s; }
.submit-section { animation-delay: 0.4s; }
</style>